import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, Power } from "lucide-react";
import {
  deleteCookie,
  AUTH_TOKEN_COOKIE,
  OUTLET_ID_COOKIE,
} from "utils/cookies";
import { getRkUser } from "../../network/externalApi";
import styles from "./RkAccountMenu.module.scss";

const pickUserName = (user) =>
  user?.Name ?? user?.name ?? user?.FullName ?? user?.fullName ?? "";

const pickUserPhone = (user) =>
  user?.PhoneNumber ??
  user?.phoneNumber ??
  user?.phone_number ??
  user?.Phone ??
  user?.phone ??
  "";

const RkAccountMenu = ({ buttonClassName }) => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [userName, setUserName] = useState("");
  const [userPhone, setUserPhone] = useState(
    (typeof window !== "undefined" &&
      (window.localStorage.getItem("rk_user_phone") ||
        window.localStorage.getItem("phone_number"))) ||
      ""
  );

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const resp = await getRkUser();
        if (cancelled) return;
        const user =
          resp?.data?.response?.user ??
          resp?.data?.response ??
          resp?.data?.user ??
          resp?.data ??
          {};
        const name = pickUserName(user);
        const phone = pickUserPhone(user);
        if (name) setUserName(name);
        if (phone) setUserPhone(String(phone));
      } catch (err) {
        /* keep drawer fields blank on failure */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleLogout = () => {
    deleteCookie(AUTH_TOKEN_COOKIE);
    deleteCookie(OUTLET_ID_COOKIE);
    window.localStorage.removeItem("rk_user_name");
    window.localStorage.removeItem("rk_user_phone");
    navigate("/rk", { replace: true });
  };

  return (
    <>
      <button
        type="button"
        className={buttonClassName || styles.menuButton}
        onClick={() => setMenuOpen(true)}
        aria-label="Open menu"
      >
        <Menu size={20} />
      </button>

      {menuOpen && (
        <>
          <div
            className={styles.overlay}
            onClick={() => setMenuOpen(false)}
            aria-hidden="true"
          />
          <div className={styles.drawer} role="dialog" aria-label="Account menu">
            <h2 className={styles.userName}>{userName}</h2>
            {userPhone ? (
              <p className={styles.userPhone}>
                {userPhone.startsWith("+") ? userPhone : `+91 ${userPhone}`}
              </p>
            ) : null}

            <div className={styles.divider} />

            <button
              type="button"
              className={styles.logout}
              onClick={handleLogout}
            >
              <Power size={18} />
              <span>Logout</span>
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default RkAccountMenu;
